import {
  Component, Input, forwardRef, HostListener, ElementRef, ViewChild, OnChanges
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface DnaSelectOption {
  value: any;
  label: string;
}

@Component({
  selector: 'dna-search-select',
  templateUrl: './dna-search-select.component.html',
  styleUrls: ['./dna-search-select.component.scss'],
  standalone: false,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DnaSearchSelectComponent),
    multi: true
  }]
})
export class DnaSearchSelectComponent implements ControlValueAccessor, OnChanges {
  @Input() options: DnaSelectOption[] = [];
  @Input() placeholder = 'Selecione...';
  @Input() disabled = false;
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  isOpen = false;
  searchTerm = '';
  selectedValue: any = null;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private _el: ElementRef) {}

  ngOnChanges(): void {}

  get selectedLabel(): string {
    return this.options.find(o => o.value == this.selectedValue)?.label || '';
  }

  get filteredOptions(): DnaSelectOption[] {
    if (!this.searchTerm.trim()) return this.options;
    const term = this.searchTerm.toLowerCase();
    return this.options.filter(o => o.label.toLowerCase().includes(term));
  }

  toggle(): void {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.searchInput?.nativeElement.focus(), 0);
    } else {
      this.searchTerm = '';
    }
  }

  select(opt: DnaSelectOption, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedValue = opt.value;
    this.onChange(opt.value);
    this.onTouched();
    this.isOpen = false;
    this.searchTerm = '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this._el.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.searchTerm = '';
    }
  }

  writeValue(val: any): void { this.selectedValue = val; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }
}
